import { useAuthUserStore } from "@/stores/authUser";
import { useJournalClassStore } from "@/stores/models/journal";

export default function pupilUserFilterEntries({ to }) {
    const authUserStore = useAuthUserStore();
    const u = authUserStore.user;
    if (!Object.hasOwnProperty.call(to.query, "user")) {
        if (u && u.level === 3) {
            const store = useJournalClassStore();
            let journal = store.item(to.params.classId);
            let canViewPeer = journal.settings?.journal?.pupil_can_view_peer_entries || false;
            if (!canViewPeer){
                // If the user is a pupil, redirect to the same page with the user id as a query parameter
                return {
                    path: to.path,
                    query: { user: u.id }
                };
            }
        }
    }
}
